"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var BillingLineUtility_1 = require("../../../utils/BillingLineUtility");
var api_1 = require("@unimaze/api-clients/lib/mapi/api");
var react_intl_1 = require("react-intl");
var IntlUtility_1 = require("../../../utils/IntlUtility");
var translationMessages = react_intl_1.defineMessages({
    billingCalculations_labels_TaxAmountWithoutVat: {
        id: "billingCalculations_labels_TaxAmountWithoutVat",
        defaultMessage: "Total amount without VAT",
    },
    billingCalculations_labels_TotalVatAmount: {
        id: "billingCalculations_labels_TotalVatAmount",
        defaultMessage: "Total VAT amount",
    },
    billingCalculations_labels_TotalAmountWithVat: {
        id: "billingCalculations_labels_TotalAmountWithVat",
        defaultMessage: "Total amount with VAT",
    },
    billingCalculations_labels_AmountPayable: {
        id: "billingCalculations_labels_AmountPayable",
        defaultMessage: "Amount payable",
    },
    billingCalculations_labels_RoundingAmount: {
        id: "billingCalculations_labels_RoundingAmount",
        defaultMessage: "Rounding amount",
    },
});
var BillingCalculations = function (props) {
    var _a = react_1.useState(props.formInstance.getFieldValue(["invoice", "invoiceLines"])), invoiceLines = _a[0], setInvoiceLines = _a[1];
    react_1.useEffect(function () {
        setInvoiceLines(props.formInstance.getFieldValue(["invoice", "invoiceLines"]));
    }, [props.outsideVatScope, props.formInstance.getFieldValue(["invoice", "invoiceLines"])]);
    var totals = {
        totalTaxableAmount: 0,
        totalTaxAmount: 0,
        totalTaxInclusiveAmount: 0,
        roundingAmount: 0,
    };
    if (invoiceLines) {
        invoiceLines.map(function (billingLine) {
            if (billingLine) {
                var taxAmount = BillingLineUtility_1.calculateTaxAmount(BillingLineUtility_1.calculateTaxableAmount(billingLine.discountValue, billingLine.quantity, billingLine.unitPriceAmount), BillingLineUtility_1.calculateTaxPercentage(billingLine.taxCategoryType ? api_1.TaxCategoryTypeEnum[billingLine.taxCategoryType] : undefined)); // BillingLineMetadataTaxCategoryTypeEnum -> TaxCategoryTypeEnum
                var taxableAmount = BillingLineUtility_1.calculateTaxableAmount(billingLine.discountValue, billingLine.quantity, billingLine.unitPriceAmount);
                var taxInclusiveAmount = taxableAmount + taxAmount;
                totals = {
                    totalTaxAmount: totals.totalTaxAmount + taxAmount,
                    totalTaxableAmount: totals.totalTaxableAmount + taxableAmount,
                    totalTaxInclusiveAmount: totals.totalTaxInclusiveAmount + taxInclusiveAmount,
                    roundingAmount: Math.abs(totals.totalTaxInclusiveAmount + taxInclusiveAmount - Math.round(totals.totalTaxInclusiveAmount + taxInclusiveAmount))
                };
            }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 18, style: { textAlign: "right" } },
                props.intl.formatMessage(translationMessages.billingCalculations_labels_TaxAmountWithoutVat),
                ":"),
            react_1.default.createElement(antd_1.Col, { span: 6, style: { textAlign: "right" } }, IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(totals.totalTaxableAmount, props.intl, { style: "decimal" }))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 18, style: { textAlign: "right" } },
                props.intl.formatMessage(translationMessages.billingCalculations_labels_TotalVatAmount),
                ":"),
            react_1.default.createElement(antd_1.Col, { span: 6, style: { textAlign: "right" } }, IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(totals.totalTaxAmount, props.intl, { style: "decimal" }))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 12, offset: 12 },
                react_1.default.createElement("hr", null))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 18, style: { textAlign: "right" } },
                react_1.default.createElement("span", { style: { fontWeight: 600 } },
                    props.intl.formatMessage(translationMessages.billingCalculations_labels_TotalAmountWithVat),
                    ":")),
            react_1.default.createElement(antd_1.Col, { span: 6, style: { textAlign: "right" } },
                react_1.default.createElement("span", { style: { fontWeight: 600 } }, IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(totals.totalTaxInclusiveAmount, props.intl, { style: "decimal" })))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 18, style: { textAlign: "right" } },
                react_1.default.createElement("span", null,
                    props.intl.formatMessage(translationMessages.billingCalculations_labels_RoundingAmount),
                    ":")),
            react_1.default.createElement(antd_1.Col, { span: 6, style: { textAlign: "right" } },
                react_1.default.createElement("span", { style: { fontWeight: 600 } }, IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(totals.roundingAmount, props.intl, { style: "decimal" })))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 12, offset: 12 },
                react_1.default.createElement("hr", null))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 18, style: { textAlign: "right" } },
                react_1.default.createElement("span", { style: { fontWeight: 600 } },
                    props.intl.formatMessage(translationMessages.billingCalculations_labels_AmountPayable),
                    ":")),
            react_1.default.createElement(antd_1.Col, { span: 6, style: { textAlign: "right" } },
                react_1.default.createElement("span", { style: { fontWeight: 600 } }, IntlUtility_1.icelandicNumberLocaleWorkaroundChrome(Math.round(totals.totalTaxInclusiveAmount), props.intl, {
                    style: "decimal"
                }))))));
};
exports.default = react_intl_1.injectIntl(BillingCalculations);
